module.exports = __webpack_public_path__ + "img/logo2.b6c61ba4.png";